import { DataFieldValue } from 'src/app/shared/datafields/models';
import { MonitorItemStatus } from './monitor-item-status';
import { AbsenceItemTemplate } from '../../shared/scheduling/models/absence-item-template';

export interface MonitorItem {
    id: number;
    monitorGroupId: number;
    stakeholderId: number;
    scheduleId: number;
    enabled: boolean;
    name: string;
    description: string;
    stakeholderUrgent: boolean;
    stakeholderContinuous: boolean;
    artifactId: string;
    embeddedTypeArea: string;
    embeddedTypeId: number;
    artifactConfig: string;
    pollingInterval: number;
    suppressToStatus: string;
    suppressMessagesCount: number;
    currentStatus: MonitorItemStatus;
    absenceItemTemplate: AbsenceItemTemplate | null;
    CreatedDate: Date;
    CreatedBy: number;
    UpdatedDate: Date;
    UpdatedBy: number;
}

export class MonitorItemClass implements MonitorItem {
    constructor(source?: Partial<MonitorItem>) {
        if (source) {
            Object.assign(this, source);
        }
    }

    id = 0;
    monitorGroupId = 0;
    stakeholderId = 0;
    scheduleId = 0;
    enabled = true;
    name = '';
    description = '';
    stakeholderUrgent = false;
    stakeholderContinuous = false;
    artifactId = null;
    embeddedTypeArea = '';
    embeddedTypeId = 0;
    artifactConfig = '';
    pollingInterval = 300;
    suppressToStatus = '';
    suppressMessagesCount = 0;
    currentStatus: MonitorItemStatus = null;
    absenceItemTemplate: AbsenceItemTemplate = null;
    CreatedDate: Date = new Date();
    CreatedBy = 0;
    UpdatedDate: Date = null;
    UpdatedBy = 0;
}

export interface MonitorItemContainer {
    monitorItem: MonitorItem;
    configValues: DataFieldValue[];
}
